import { SITE_NAME, SITE_URL, DEFAULT_IMAGE, CONTACT_PHONE, SOCIAL_LINKS } from "./seoConfig";
import { toMetaDescription, toAbsoluteUrl } from "./seoUtils";

// Only ever includes properties backed by real API data. Never fabricates
// ratings, reviews, availability, or offer data that isn't actually present.
export const buildPackageJsonLd = (pkg, canonicalUrl) => {
  if (!pkg || !pkg.name) return null;

  const description = toMetaDescription(pkg.overview, 300);
  const price = Array.isArray(pkg.price) ? pkg.price[0] : pkg.price;
  const images = Array.isArray(pkg.image) ? pkg.image.filter(Boolean) : [];

  return {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    name: pkg.name,
    ...(description ? { description } : {}),
    ...(images.length ? { image: images } : {}),
    ...(canonicalUrl ? { url: canonicalUrl } : {}),
    ...(price
      ? {
          offers: {
            "@type": "Offer",
            price: String(price),
            priceCurrency: "INR",
            ...(canonicalUrl ? { url: canonicalUrl } : {}),
          },
        }
      : {}),
  };
};

// Only includes `author` when the API actually returns a post/author name;
// no publish/modified dates are added since BlogDetails does not return any.
export const buildBlogJsonLd = (blog, canonicalUrl) => {
  if (!blog || !blog.Title) return null;

  const description = toMetaDescription(blog.LongDescription, 300);
  const image = toAbsoluteUrl(blog.Image);

  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: blog.Title,
    ...(description ? { description } : {}),
    ...(image ? { image } : {}),
    ...(canonicalUrl
      ? { url: canonicalUrl, mainEntityOfPage: canonicalUrl }
      : {}),
    ...(blog.Post ? { author: { "@type": "Person", name: blog.Post } } : {}),
  };
};

// Site-wide business schema. Every field here is already publicly published
// elsewhere in this codebase (share links / tel: links in PackageDestination.jsx
// and ContactUs.jsx) - nothing here is invented.
export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  name: SITE_NAME,
  url: SITE_URL,
  logo: DEFAULT_IMAGE,
  telephone: CONTACT_PHONE,
  sameAs: SOCIAL_LINKS,
};
